import api from "@/services/api.ts";
import {AllCriteria, Criteria} from "@/types/Criteria.ts";

export const createItem = async (modelName: string, item: Criteria): Promise<Criteria> => {
    const response = await api.post(`/${modelName}`, item);
    return response.data;
};

export const listItems = async (modelName: string): Promise<Criteria[]> => {
    const response = await api.get(`/${modelName}`);
    return response.data;
};

export const showItem = async (modelName: string, id: number): Promise<Criteria | null> => {
    try {
        const response = await api.get(`/${modelName}/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return null;
        }
        throw error;
    }
};

export const updateItem = async (modelName: string, id: number, item: Criteria): Promise<Criteria> => {
    const response = await api.put(`/${modelName}/${id}`, item);
    return response.data;
};

export const removeItem = async (modelName: string, id: number): Promise<void> => {
    await api.delete(`/${modelName}/${id}`);
};

export const getItemsOfAllTypes = async (): Promise<AllCriteria> => {
    const response = await api.get("/all-criteria");
    return response.data;
}
